export enum LocalStorage {
  USER = 'Aritronix.user',
  JWT = 'jwt'
}

export enum Messages {
  SESSION_EXPIRED = 'Session expired. Please login again.'
}
